import styles from './ContinueButton.module.scss';
import cn from 'classnames';
export const ContinueButton = ({ children, className, status, ...props }) => {
  return (
    <div className={cn(styles.button, className, status === "disabled" && styles.disabled)} {...props}>{children || "Continue"}</div>
  )
}